import { useQueryClient } from '@tanstack/react-query';
import { getFindProductGridRootKey } from '../../../services/modules/product-grid/product-grid.keys';
import useOrderProductsReloadStore from '../../../stores/OrderProductsReload/orderProductsReload.store';
import { RachelResource } from '../../rachel/effects/uiEffect.schema';
import { useRachelEventListener } from '../../rachel/effects/useRachelEventListener';
import { validateOrderProductsQuery } from '../contexts/order.utils';

export const useOrderRachelSync = (orderId: string, teamId?: string): void => {
  const queryClient = useQueryClient();

  useRachelEventListener({
    resource: RachelResource.ORDER,
    scopeId: orderId,
    onChange: () => {
      queryClient.refetchQueries(validateOrderProductsQuery(orderId, teamId));
      queryClient.refetchQueries({
        queryKey: [teamId, ...getFindProductGridRootKey()],
        type: 'active',
      });
      useOrderProductsReloadStore.getState().requestReload(orderId);
    },
  });
};
